import React, { createContext, useContext, ReactNode } from 'react';
import { useAITranslation, Language, supportedLanguages } from '../hooks/useAITranslation';

interface LanguageContextType {
  currentLanguage: Language;
  changeLanguage: (languageCode: string) => void;
  supportedLanguages: Language[];
  isTranslating: boolean;
  refreshOriginalTexts: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const { currentLanguage, changeLanguage, isTranslating, refreshOriginalTexts } = useAITranslation();

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      supportedLanguages,
      isTranslating,
      refreshOriginalTexts
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Export types for other components
export type { Language };